import { render, staticRenderFns } from "./AccessPolicyEditNode.vue?vue&type=template&id=bda38e42&"
import script from "./AccessPolicyEditNode.vue?vue&type=script&lang=ts&"
export * from "./AccessPolicyEditNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports